import { LangueEnum } from '../constantes/Langue.enum';
import { Pipe, PipeTransform } from '@angular/core';
import { LangueService } from '../services/langue/langue.service';
import { TelephoneBancaire } from '../api/model/telephone-bancaire.model';

@Pipe({
  name: 'phone',
  standalone: false,
})
export class PhonePipe implements PipeTransform {
  isFrancais: boolean;
  private readonly maskFr: string = '$1 $2-$3';
  private readonly maskEn: string = '$1-$2-$3';
  private readonly regSpaceDash: RegExp = /(-)|( )*/g;
  private readonly regNumberByGroup: RegExp = /^(\d{0,3})(\d{0,3})(\d{0,4})/;
  private readonly posteFr: string = ', poste ';
  private readonly posteEn: string = ', ext. ';

  constructor(private readonly langueService: LangueService) {}

  transform(tel: string | TelephoneBancaire): string {
    let numero = '';
    let poste = '';
    const isFrancais = this.langueService.getCurrentLanguage() === LangueEnum.FR;

    if (typeof tel === 'string') {
      numero = tel;
    } else if (typeof tel === 'object' && tel !== null) {
      numero = tel.numeroTelephone;
      poste = tel.numeroPoste ?? '';
    }

    if (!numero) {
      return '';
    }

    numero = numero.replace(this.regSpaceDash, '');
    let formatted = numero.replace(this.regNumberByGroup, isFrancais ? this.maskFr : this.maskEn);
    formatted = formatted.trim().replace(/[-\s]+$/, '');

    if (poste) {
      formatted += isFrancais ? this.posteFr + poste : this.posteEn + poste;
    }

    return formatted;
  }
}
